import { nameOfFactory } from "@libs/utils/name-of.utils.ts";

export interface ClinicalReminderPreferenceFormValues {
  allowReminderFreeText: boolean;
  useReminderMinRange: boolean;
  reminderMinWeekRange: number;
}

export const nameOfClinicalReminderPreferences =
  nameOfFactory<ClinicalReminderPreferenceFormValues>();
